// import React from "react";

export const animSetting = {
    ease: "expo.out",
    duration: 0.6
};